import type { CityConfig } from "../city-template/types";

export const libertyMOConfig: CityConfig = {
  city: "Liberty",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "liberty-mo",
  route: "/cities/liberty-mo",
  title: "Emergency Passport Liberty, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Liberty, MO — as fast as 24 hours. Serving Clay County and the Kansas City Northland. A+ BBB rated registered State Dept. courier serving the historic Liberty Square area. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Liberty, MO",
  heroSubtitle: "Kansas City Northland business trip to Toronto with one week's notice? Clay County family vacation to Scotland and the passports expired? William Jewell College study abroad needs fast documents? We help Liberty residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Liberty%20Missouri%20Clay%20County%20town%20square%20with%20red%20brick%20buildings%20courthouse%20clock%20tower%20William%20Jewell%20College%20campus%20KC%20Northland%20suburban%20landscape%20green%20trees%20golden%20hour%20warm%20light%20professional%20photography%20Midwest%20charm&width=1800&height=700&seq=liberty-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Historic Liberty Missouri Clay County downtown square at golden hour",
  geoPosition: "39.2461;-94.4191",
  geoPlacename: "Liberty, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 480 miles east of Liberty via I-35/I-80",
  },
  nearbyCitiesZips: [
    { name: "Liberty", zips: "64068" },
    { name: "Kearney", zips: "64060" },
    { name: "Smithville", zips: "64089" },
    { name: "Gladstone", zips: "64118, 64119" },
    { name: "North Kansas City", zips: "64116" },
    { name: "Parkville", zips: "64152" },
    { name: "Platte City", zips: "64079" },
    { name: "Excelsior Springs", zips: "64024" },
    { name: "Claycomo", zips: "64119" },
    { name: "Pleasant Valley", zips: "64068" },
    { name: "Riverside", zips: "64150" },
    { name: "Kansas City (North)", zips: "64151, 64152, 64153" },
    { name: "Independence", zips: "64050, 64052, 64055" },
    { name: "Blue Springs", zips: "64014, 64015" },
    { name: "Richmond", zips: "64085" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Clay County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "KC Northland Hub", desc: "Serving Liberty, Kearney, Smithville, and the entire I-35 North corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Fast passport renewal in Independence, MO", route: "/cities/independence-mo" },
    { name: "Emergency passport help in Lee's Summit, MO", route: "/cities/lees-summit" },
    { name: "Urgent passport services in St. Joseph, MO", route: "/cities/st-joseph-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Columbia, MO", route: "/cities/columbia-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Liberty remotely via secure courier. We do not have a walk-in office in Liberty — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Clay County and the Kansas City Northland.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Clay County and the Kansas City Northland including Platte County and Clinton County",
  serviceAreaIntro: "From the historic Liberty Square and the tree-lined campus of William Jewell College to the growing subdivisions along 291 Highway, from the charming downtown of Kearney to the lakeside community of Smithville, from the suburban neighborhoods of Gladstone and the riverside communities of Parkville — Fast Passport Center serves the entire Kansas City Northland. We regularly help travelers from Clay County, Platte County, and surrounding areas get their passports fast without the 8-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Liberty neighborhoods and the surrounding Kansas City Northland area including Kearney, Smithville, Gladstone, North Kansas City, Parkville, Excelsior Springs, and Platte City. If you are anywhere in Clay County, Platte County, or the I-35 North corridor, we have you covered.",
  howItWorksIntro: "Most Liberty travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Liberty travelers often face an 8-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Liberty and Clay County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Liberty? Here are the most common ones we hear from Kansas City Northland travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (Missouri Vital Records)", url: "https://health.mo.gov/data/vitalrecords/", desc: "Missouri Department of Health — Vital Records for birth and death certificates statewide" },
    { label: "Marriage Licenses (Clay County Recorder)", url: "https://www.claycountymo.gov/", desc: "Clay County Recorder of Deeds for Liberty and Clay County" },
    { label: "Divorce Decrees (Clay County Circuit Court)", url: "https://www.courts.mo.gov/", desc: "Clay County Circuit Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Missouri vital records online via VitalChek" },
  ],
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Liberty travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "David L.",
      location: "Liberty, MO",
      rating: 5,
      text: "Had a business trip to Singapore with 5 days notice and realized my passport was expired. Fast Passport Center got my renewal back in 31 hours. I never left Liberty. From the historic square to Southeast Asia in under a week!",
      service: "Passport Renewal",
    },
    {
      name: "Amanda P.",
      location: "Kearney, MO",
      rating: 5,
      text: "Family emergency in France — needed passports for all four of us. Fast Passport Center handled it all. Got them in 28 hours. The dedicated agent was incredible. Clay County's best-kept secret.",
      service: "Emergency Passport",
    },
    {
      name: "Jeff W.",
      location: "Smithville, MO",
      rating: 5,
      text: "Daughter's study abroad in Barcelona and her passport was expired. Fast Passport Center got it in 3 days. The only service that gave us daily updates. Huge relief for KC Northland parents.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "liberty-1",
      name: "Liberty Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Stewart St",
      city: "Liberty",
      state: "MO",
      zip: "64068",
      phone: "(816) 781-4411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Liberty",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Liberty facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "liberty-2",
      name: "Clay County — Annex Office",
      type: "County Government Passport Acceptance",
      address: "1 Courthouse Square",
      city: "Liberty",
      state: "MO",
      zip: "64068",
      phone: "(816) 407-3874",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Historic Liberty Square",
      website: "https://www.claycountymo.gov",
      websiteLabel: "Clay County Recorder",
      notes: "Accepts passport applications at the county seat. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "liberty-3",
      name: "Gladstone Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 NE 70th St",
      city: "Gladstone",
      state: "MO",
      zip: "64118",
      phone: "(816) 436-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles south of Liberty",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Gladstone and southern Clay County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "liberty-4",
      name: "Kearney Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E 6th St",
      city: "Kearney",
      state: "MO",
      zip: "64060",
      phone: "(816) 628-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles northeast of Liberty",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kearney and northern Clay County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "liberty-5",
      name: "Parkville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E 12th St",
      city: "Parkville",
      state: "MO",
      zip: "64152",
      phone: "(816) 741-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles southwest of Liberty",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Parkville and Platte County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Liberty photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Clay County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Liberty applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many KC Northland families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Liberty travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Liberty." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Liberty address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Liberty before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Liberty for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Liberty?", a: "Fast Passport Center offers fast passport renewal in Liberty in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Liberty?", a: "The nearest regional passport agency to Liberty is the Chicago Passport Agency, approximately 480 miles east via I-35/I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Liberty without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Liberty?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 8 hours from Liberty — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Clay County and KC Northland residents." },
    { q: "Do you serve the entire Kansas City Northland?", a: "Absolutely. Fast Passport Center serves the entire Kansas City Northland including Liberty, Kearney, Smithville, Gladstone, North Kansas City, Parkville, and surrounding areas. Our courier service works seamlessly from any address in Clay County and Platte County." },
    { q: "Can I expedite a child passport in Liberty?", a: "Yes. Fast Passport Center expedites child passports in Liberty for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk KC Northland families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Liberty with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Liberty", address: "8301 N Church Rd, Kansas City, MO 64158", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Liberty", address: "100 S Stewart Rd, Liberty, MO 64068", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Gladstone", address: "5913 NE Antioch Rd, Gladstone, MO 64119", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Kearney", address: "1100 N Jefferson St, Kearney, MO 64060", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Liberty License Office",
      address: "1170 W Kansas St, Liberty, MO 64068",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Gladstone License Office",
      address: "6040 NE Antioch Rd, Gladstone, MO 64119",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Gladstone and southern Clay County. REAL ID available.",
      featured: false,
    },
    {
      name: "Missouri DOR — Platte City License Office",
      address: "11724 NW Plaza Cir, Kansas City, MO 64153",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Platte County. REAL ID available. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "20 miles southwest of Liberty",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with direct flights worldwide. About 25 minutes from Liberty via I-35 South.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "MKC",
      name: "Charles B. Wheeler Downtown Airport",
      distance: "18 miles south of Liberty",
      address: "10 Richards Rd, Kansas City, MO 64116",
      note: "General aviation and regional charter airport. About 25 minutes from Liberty.",
      flightUrl: "https://www.flymkc.com/",
      flightLabel: "MKC Airport",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "250 miles east of Liberty",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major airport serving eastern Missouri. About 4 hours from Liberty via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
  ],
};